import React from 'react'
import CredentialSharingNagGuard from './CredentialSharingNagGuard'
import Head from './Head'
import Header, { HeaderContextProvider } from './Header'
import LegalDocsNagGuard from './LegalDocsNagGuard'
import ScrollToTop from './ScrollToTop'

type Props = {
  children: React.ReactNode
}

const AppLayout = ({ children }: Props) => (
  <ScrollToTop>
    <HeaderContextProvider>
      <div className="full-height">
        <Head />
        <Header />
        <LegalDocsNagGuard />
        <CredentialSharingNagGuard />
        <main className="full-height">{children}</main>
      </div>
    </HeaderContextProvider>
  </ScrollToTop>
)

export default AppLayout
